/**
 * Created by gbray on 06/03/2017.
 */
export class ActionModel {
  public displayEditButton = false;
  public displayDuplicateButton = false;
  public displayDuplicateMasseButton = false;
  public displayReturnButton = false;
  public displayValidationButton = false;
  public displayAddNewRightButton = false;
  public displaySubmitToValidationButton = false;
  public displaySubmitToValidationByMailButton = false;
  public displayPostButton = false;
  public displayUpdateButton = false;
  public displayDeleteButton = false;
  public displayAddButton = false;
  public displayCancelButton = false;
  public displayCreateDuplicateButton = false;
  public displaySignButton = false;
  public displayProtectButton = false;
  public displayDownloadDraftPdfButton = false;
  public displayDownloadPdfButton = false;
  public displayAddInSessionButton = false;
  public displayUpdateInSessionButton = false;
  public displayUndoConfirmButton = false;
  public displayEmailButton = false;
  public displaySendNodNotification = false;
  public displayNodButton = false;
  public displayWorkflowButton = false;
  public displayRefuseButton = false;
  public displayClosingDate = false;
  public displayDownloadXlsxButton = false;
  public displaySecondDownloadXlsxButton = false;
  public displayDuplicationValidation = false;
  public displaySetOkNotification = false;
  public displayAllValidationButton = false;
  public displayDownloadDocument = false;
  public displayPdfButton = false;
  public displayUseAsModel = false;
  public displayCancelTurnoverButton = false;
  public displayExcelImport = false;
  public displayTakeTurnoverButton = false;
  public displayTurnoverSaveButton = false;
  public displaySetOkFacturationButton = false;
  public displaySGenerateInvoiceAllButton = false;
  public displayCreateContractButton = false;
  public displayImportDocument = false;
  public displayPostLineExtraction = false;
  public displayDeliveryButton = false;
  public displaySettingsButton = false;
  public displaySearchButton = false;

  public saveCriteria = false;
  public applyCriteria = false;

  public module: string;

  constructor() {}

  public isAllFalse() {
    let isAllFalse = true;

    if (this.saveCriteria === true) {
      isAllFalse = false;
    }

    if (this.applyCriteria === true) {
      isAllFalse = false;
    }

    if (this.displayEditButton === true) {
      isAllFalse = false;
    }

    if (this.displayDuplicateButton === true) {
      isAllFalse = false;
    }

    if (this.displayDuplicateMasseButton === true) {
      isAllFalse = false;
    }

    if (this.displayReturnButton === true) {
      isAllFalse = false;
    }
    if (this.displayValidationButton === true) {
      isAllFalse = false;
    }

    if (this.displayAddNewRightButton === true) {
      isAllFalse = false;
    }

    if (this.displaySubmitToValidationButton === true) {
      isAllFalse = false;
    }
    if (this.displayPostButton === true) {
      isAllFalse = false;
    }
    if (this.displayUpdateButton === true) {
      isAllFalse = false;
    }
    if (this.displayDeleteButton === true) {
      isAllFalse = false;
    }
    if (this.displayAddButton === true) {
      isAllFalse = false;
    }
    if (this.displayCancelButton === true) {
      isAllFalse = false;
    }
    if (this.displayCreateDuplicateButton === true) {
      isAllFalse = false;
    }
    if (this.displaySignButton === true) {
      isAllFalse = false;
    }
    if (this.displayProtectButton === true) {
      isAllFalse = false;
    }
    if (this.displayDownloadDraftPdfButton === true) {
      isAllFalse = false;
    }
    if (this.displayAddInSessionButton === true) {
      isAllFalse = false;
    }
    if (this.displayUpdateInSessionButton === true) {
      isAllFalse = false;
    }
    if (this.displayUndoConfirmButton === true) {
      isAllFalse = false;
    }
    if (this.displayEmailButton === true) {
      isAllFalse = false;
    }
    if (this.displaySendNodNotification) {
      isAllFalse = false;
    }
    if (this.displayNodButton === true) {
      isAllFalse = false;
    }
    if (this.displayWorkflowButton === true) {
      isAllFalse = false;
    }
    if (this.displayRefuseButton === true) {
      isAllFalse = false;
    }
    if (this.displayClosingDate === true) {
      isAllFalse = false;
    }
    if (this.displayRefuseButton === true) {
      isAllFalse = false;
    }
    if (this.displayDownloadXlsxButton === true) {
      isAllFalse = false;
    }
    if (this.displaySecondDownloadXlsxButton === true) {
      isAllFalse = false;
    }
    if (this.displayDuplicationValidation === true) {
      isAllFalse = false;
    }
    if (this.displaySetOkNotification === true) {
      isAllFalse = false;
    }
    if (this.displayAllValidationButton === true) {
      isAllFalse = false;
    }
    if (this.displayDownloadDocument === true) {
      isAllFalse = false;
    }
    if (this.displayUseAsModel === true) {
      isAllFalse = false;
    }
    if (this.displayPdfButton) {
      isAllFalse = false;
    }
    if (this.displayTakeTurnoverButton === true) {
      isAllFalse = false;
    }
    if (this.displayCancelTurnoverButton === true) {
      isAllFalse = false;
    }
    if (this.displayTurnoverSaveButton === true) {
      isAllFalse = false;
    }
    if (this.displaySetOkFacturationButton === true) {
      isAllFalse = false;
    }
    if (this.displaySGenerateInvoiceAllButton === true) {
      isAllFalse = false;
    }
    if (this.displayCreateContractButton === true) {
      isAllFalse = false;
    }
    return isAllFalse;
  }
}
